import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Card } from 'react-bootstrap';
import * as ControlPanelApi from '../../../api/ControlPanelApi';
import { PAGE_LENGTH } from '../../../common/constants';
import { handleApiError } from '../../../common/errorHandler';
import DataTable from '../../../components/DataTable';
import { PageBody } from '../../../components/SiteWrapper';
import { formatDateTime } from '../../../utils/DateFormat';
import PageHeaderActions from '../../../components/General/PageHeaderActions';
import AddEditCities from '../../Setup/Cities/AddEditCities';
import Actions from '../../../components/DataTable/Actions';
import * as RrbApi from '../../../api/RrbAPI';

const DEFAULT_CITY_MODAL = {
  id: null,
  show: false,
  title: 'Add City',
  saveBtnText: 'Save',
  action: 'ADD',
  rrb: null,
  state: null,
};

export default function CitiesTable() {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [cityModal, setCityModal] = useState(DEFAULT_CITY_MODAL);
  const [allRrb, setAllRrb] = useState(null);

  const [filter, setFilter] = useState({
    _page: 1,
    _limit: 10,
    q: '',
    _sort: 'id',
    _order: 'asc',
    isDelete: null,
  });

  const initialState = {
    sortBy: [{ id: 'id', desc: false }],
    pageSize: filter._limit,
    pageIndex: 0,
  };

  const AddCity = () => {
    setCityModal((preveState) => ({
      ...preveState,
      show: true,
    }));
  };
  const resetCityModal = (isReload = false) => {
    setCityModal(DEFAULT_CITY_MODAL);
    if (isReload === true) {
      fetchCities();
    }
  };

  const fetchCities = useCallback(async () => {
    setIsLoading(true);
    try {
      await ControlPanelApi.getDivisionCities(filter).then(({ data }) => {
        if (data?.divisionCities) {
          setRows(data?.divisionCities);
          setTotalRecords(data?.totalRecords);
        }
      });
      if (!allRrb) {
        await RrbApi.getAll().then((data) => {
          setAllRrb(
            data?.data?.records?.map((rrb) => {
              return {
                id: rrb.id,
                name: `${rrb.name} ${rrb.city}`,
              };
            })
          );
        });
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  }, [filter]);

  const EditCity = (row) => {
    setCityModal({
      id: row.original.id,
      show: true,
      title: 'Edit City',
      action: 'EDIT',
      saveBtnText: 'Save',
      rrb: row.original.Rrb,
      state: row.original.state,
    });
  };

  useEffect(() => {
    const getData = setTimeout(() => {
      fetchCities();
    }, 100);
    return () => clearTimeout(getData);
  }, [filter]);

  const extraSelectOptions =
    allRrb?.map((rrb) => ({
      key: rrb.id,
      label: rrb.name,
    })) ?? [];
  const columns = useMemo(
    () => [
      {
        Header: 'RRB',
        accessor: 'Rrb',
        className: 'text-nowrap',
        disableSortBy: true,
        width: '200',
        Cell: ({ value }) => {
          return value ? `${value.name + ` (${value.city})`}` : 'N/A';
          // value || "N/A"
        },
      },
      {
        Header: 'City',
        accessor: 'city',
        className: 'text-nowrap w-auto',
        disableSortBy: true,
        width: '250',
      },
      {
        Header: 'State',
        accessor: 'state',
        className: 'text-nowrap w-auto',
        disableSortBy: true,
        width: '250',
      },
      {
        Header: 'Last Updated',
        accessor: 'updated_at',
        className: 'text-nowrap',
        disableSortBy: true,
        width: '200',
        Cell: ({ row }) => {
          const updateAt = formatDateTime(row.original.updated_at);
          return <span role='button'>{`${updateAt}`}</span>;
        },
      },
      {
        Header: 'Added',
        accessor: 'created_at',
        className: 'text-nowrap',
        disableSortBy: true,
        width: '200',
        Cell: ({ row }) => {
          const createdAt = formatDateTime(row.original.created_at);

          return <span role='button'>{`${createdAt} `}</span>;
        },
      },
      {
        Header: '',
        accessor: 'id',
        className: 'w-auto',
        enableRowSpan: true,
        disableSortBy: true,
        Cell: ({ row }) => (
          <Actions
            row={row}
            onEdit={EditCity}
            // onDelete={DeleteExam}
            // onPreview={OnPreview}
          />
        ),
      },
    ],
    []
  );
  return (
    <PageBody>
      {/* <Card md="12" className='p-0'>
        <Card.Header className="bg-light-rrb">
          <h3 className="card-title fw-bold">Centers</h3>
        </Card.Header>
        <Card.Body className="p-0"> */}
      <DataTable
        header={
          <PageHeaderActions
            title='Cities'
            actionText='Add'
            onClick={AddCity}
          />
        }
        columns={columns}
        data={rows}
        initialState={initialState}
        totalRecords={totalRecords}
        setFilter={setFilter}
        tableHooks={() => {}}
        defaultPageLength={PAGE_LENGTH}
        isLoading={isLoading}
        manual={true}
        align='table-vcenter'
        extraSelectFilter={true}
        extraSelectOptions={extraSelectOptions}
        defaultOption={{ key: null, label: 'Select Recruitment Board' }}
        setSelectState={(id) => {
          setFilter((prev) => ({ ...prev, q: id }));
        }}
      />
      {/* </Card.Body>
      </Card > */}

      {cityModal.show && <AddEditCities {...{ cityModal, resetCityModal }} />}
    </PageBody>
  );
}
